"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radim Krkoška
 */


var SiteFormatChangeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteFormatChangeConverter, _DataObjectConverter_);

  function SiteFormatChangeConverter() {
    _classCallCheck(this, SiteFormatChangeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteFormatChangeConverter).apply(this, arguments));
  }

  return SiteFormatChangeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteFormatChangeConverter = SiteFormatChangeConverter;